module.exports = __webpack_public_path__ + "img/btw1.b884e561.jpg";